// @flow
import * as actions from './duck/actions';
import * as selectors from './duck/selectors';
import reducer from './duck/reducer';

export { actions, selectors };
export * from './duck/model';
export default reducer;
